import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useLists = () =>
  useStore(store => store.loadLists.state)
